import { FunctionComponent } from 'react';

import {
  UI_SHAPE,
  UiShape,
} from '@savgroup-front-common/constants/shared/shape';
import { Avatar, AvatarFallback } from '../../atoms/Avatar/Avatar';
import { AVATAR_SIZE, AvatarSize } from '../../atoms/Avatar/Avatar.types';

import { getAvatarVariant, getInitials } from './AvatarUser.helpers';

interface AvatarUserProps {
  size?: AvatarSize;
  shape?: UiShape;
  isHeader?: boolean;
  fullName?: string;
}

export const AvatarUser: FunctionComponent<AvatarUserProps> = ({
  size = AVATAR_SIZE.MD,
  isHeader = false,
  shape = UI_SHAPE.ROUND,
  fullName = '',
}) => {
  return (
    <Avatar
      variant={getAvatarVariant(fullName)}
      shape={shape}
      size={size}
      isHeader={isHeader}
    >
      <AvatarFallback>{getInitials(fullName)}</AvatarFallback>
    </Avatar>
  );
};
